import { useState } from "react";
import { HubspotPickerDataAsscoiatedObjectOptionItem } from "../interfaces";
import SmallTextInputField from "./SmallTextInputField";

interface Props {
  contactOptions: Array<HubspotPickerDataAsscoiatedObjectOptionItem>;
  index: number;
  value: string;
  initialValue: string;
  setSignatureOverrideRecipients: (index: number, value: string) => void;
  active: boolean;
}

function AppHubspotPickerSignatureEmailInput(props: Props) {

  const [isFocused, setIsFocused] = useState(false);
  const [isHoveringOptions, setIsHoveringOptions] = useState(false);
  const [optionIndex, setOptionIndex] = useState(-1);

  const filetedContacts = props.contactOptions.filter((contact) => !!contact.email && (contact.label + (contact.email ?? "")).toLowerCase().includes((props.value ?? "").toLowerCase()));
  const hasOptions = filetedContacts.length > 0;

  function handleUpdateOptionIndex(e: React.KeyboardEvent<HTMLDivElement>) {
    if (!hasOptions)
      return;

    if (e.key === "ArrowDown") {
      setOptionIndex((prev) => (prev + 1) % filetedContacts.length);
    } else if (e.key === "ArrowUp") {
      setOptionIndex((prev) => (prev + filetedContacts.length - 1) % filetedContacts.length);
    }

    if (e.key === "Enter") {
      const contact = filetedContacts[optionIndex];
      props.setSignatureOverrideRecipients(props.index, contact!.email!);
    }
  }

  const isTag = !!props.initialValue.match(/\{\{.*\}\}/);

  return (
    <div className="relative flex-shrink-0">
      <SmallTextInputField key={props.index} label={`Recipient #${props.index + 1}`} placeholder="Email address" value={props.value} onChange={(value) => { props.setSignatureOverrideRecipients(props.index, value); setOptionIndex(n => Math.min(n, filetedContacts.length - 1)) }} disabled={isTag || props.active} onFocus={() => setIsFocused(true)} onBlur={() => setIsFocused(!(hasOptions && !isHoveringOptions))} onKeyDown={handleUpdateOptionIndex} />
      {(isFocused && hasOptions) &&
        <div className="flex flex-col absolute shadow border border-t-0 rounded-sm w-full z-50 bg-white max-h-72 overflow-y-auto" onMouseEnter={() => setIsHoveringOptions(true)} onMouseLeave={() => setIsHoveringOptions(false)}>
          {filetedContacts.map((contact: any, index: number) => (
            <div key={contact.email} className={`p-1 hover:bg-blue-50 cursor-pointer flex flex-col text-sm ${index === optionIndex ? "bg-blue-50" : "bg-white"}`} onClick={() => { props.setSignatureOverrideRecipients(props.index, contact.email); setIsFocused(false); }}>
              <div className="font-gilroy font-semibold text-gray-600">
                {contact.label}
              </div>
              <div className="text-xs text-gray-400 font-semibold">
                {contact.email}
              </div>
            </div>
          ))}
        </div>
      }
    </div>
  );
}

export default AppHubspotPickerSignatureEmailInput;
